import React, {FC, useEffect, useMemo, useRef, useState} from 'react';
import {useSession} from 'next-auth/react';
import {initializeApollo} from '@utils/apollo-client';
import {ApolloProvider} from '@apollo/client';

export type AuthorizedApolloClientProps = {
    initialCache: any;
};

export const AuthorizedApolloClient: FC<AuthorizedApolloClientProps> = ({children, initialCache}) => {
    const {data} = useSession();
    const sessionRef = useRef(data);
    const apolloClient = useMemo(() => {
        return initializeApollo(initialCache, sessionRef);
    }, [initialCache]);

    useEffect(() => {
        sessionRef.current = data;
    }, [data]);

    return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
};
